import { render, staticRenderFns } from "./EventParticipantCardView.vue?vue&type=template&id=61e95c60&"
import script from "./EventParticipantCardView.vue?vue&type=script&lang=js&"
export * from "./EventParticipantCardView.vue?vue&type=script&lang=js&"
import style0 from "./EventParticipantCardView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports